import { Component, OnInit } from '@angular/core';

import * as echarts from 'echarts';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { debounceTime, forkJoin, Observable, of, Subject, Subscription, switchMap, tap } from 'rxjs';
import { DatePipe } from '@angular/common';
import { createChartSingle } from 'src/app/shared/commen-function-file';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';


interface Month {
  key: number;
  name: string;
}
@Component({
  selector: 'app-attrition-salary-leave-wise',
  templateUrl: './attrition-salary-leave-wise.component.html',
  styleUrls: ['./attrition-salary-leave-wise.component.scss'],
})
export class AttritionSalaryLeaveWiseComponent  implements OnInit {
  isUserEmployee: boolean = false;
  graphType: string = 'bar';  // Default chart type

  
  pmsYears: any = [];
  loggedInCompanyFiscalyear: any;
  setupGradeBrand: any;
  setUpyearRange: any;
  loggedInUserEmpCode: any | null;
  buttonColorName: any | null;
  subModuleButtonColor: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  loggedInUserCompanyID:any;
  selectedYearForCompetency: any = null;
  selectedYear:any=null; 
  fromYear: any;
  toYear: any;
  arrAllMonths: any = [];
  selectedMonth: any;
  variableFrequency: any;
  frequencies: string[] = ["Monthly", "Quaterly", "Semi-Annually", "Annually"];
  setupFrequency: any = null;
  filteredFrequencies: string[] = [];
  filteredFrequenciesSummary: string[] = [];
  filteredFrequenciesVariable: any;
  frequencyName!: string;
  setupMonths: any = [];
  frequencyPeriod: any = null;
  isVPSetupDone: boolean = false;
  isVPInputSetupNotDone: boolean = false;
  cutOffDays: number | null = null;
  GetOverallIncrementBudgetGridData: any = [];
  fromMonth: any = null;
  toMonth: any = null;
  cutOffDate: any;
  previousOverallVPBudgetGrid: any = [];
  selectedMonths: string[] = [];
  cutOffDateForVariablepay!: string;
  getMonthsToVariablePay: string[] = [];
  allMonths: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  toMonthsVariablePay: string[] = [];
  cutOffDaysChange: Subject<string> = new Subject<string>();

  selectedMonthName: any;
  previousMonthsCountAprilMarch: any;
  previousMonthsCountJanDec: any;

  constructor( private encryptionService: EncryptionService,
      private httpService: HttpService, private config: Config,
    public sharedService: SharedService, private datePipe: DatePipe,  private PdfDownload: PdfDownloadService) { }

  ngOnInit() {
    
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
    this.cutOffDaysChange
    .pipe(debounceTime(300)) // Debounce for 300ms, adjust as needed
    .subscribe(day => this.processCutoffDateInput(day));
  }
  
  switchGraphType(type: string) {
    this.graphType = type;
    // this.loadGraph();
  }

  downloadGraph() {
  
  }


// hi

tableData: { lowerEnd: string; higherEnd: string }[] = [];
showInputs: boolean = false;
maxRange: number | any = null;
scoreRange: number | any = null;
errMsgMaxRange: boolean = false;
showMaxRangeError: boolean = false;
errorMessage: string = '';
restrictToEditSetup: boolean = false;
isInValidMaxRange: boolean = false;

isLastMaxRange100(): boolean {
  if (this.tableData.length === 0) {
    return false;
  }
  return Number(this.tableData[this.tableData.length - 1].higherEnd) === 100;
}

toggleInputs() {
  if (this.showInputs) {
    this.saveData();
  } else {
    if (this.isLastMaxRange100()) {
      alert('Max Range of 100 already reached. You cannot add more ranges.');
      return;
    }
    this.scoreRange = this.tableData.length > 0 ? Number(this.tableData[this.tableData.length - 1].higherEnd) : 0;
  }
  this.showInputs = !this.showInputs;
}

saveData() {
  this.showMaxRangeError = false;
  if (this.maxRange == null) {
    this.errMsgMaxRange = true;
    return;
  }
  this.errMsgMaxRange = false;
  const maxRangeNum = Number(this.maxRange);

  if (maxRangeNum > 100) {
    alert('Validation failed: max range cannot exceed 100.');
    return;
  }
  if (this.isLastMaxRange100() && maxRangeNum !== 100) {
    alert('Validation failed: The maximum range must be 100 to proceed.');
    return;
  }
  this.tableData.push({
    lowerEnd: this.scoreRange!.toString(),
    higherEnd: this.maxRange.toString()
  });
  this.resetFormFields();
  this.showInputs = false;
}

onMaxRangeChange(data: { maxRange: number | string; minRange: number }): void {
  const maxRange = typeof data.maxRange === 'string' ? Number(data.maxRange) : data.maxRange;
  if (isNaN(maxRange) || maxRange <= data.minRange || maxRange <= 0) {
    this.isInValidMaxRange = true;
    this.maxRange = null;
  } else {
    this.isInValidMaxRange = false;
  }
}

preventNegative(event: KeyboardEvent): void {
  if (event.key === '-' || event.key === 'e' || event.key === '+') {
    event.preventDefault();
  }
}

removeInputs() {
  this.showInputs = false;
  this.resetFormFields();
}

resetFormFields() {
  this.scoreRange = null;
  this.maxRange = null;
  this.isInValidMaxRange = false;
}

    
// getpmsyearlist() {
//   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
//     this.pmsYears = [];

//     data?.data?.yearRanges?.forEach((ele: any) => {
//       var test = ele.split('_');
//       let obj = {
//         year: test[0] + '-' + test[1]
//       };

//       // Get current year
//       const currentYear = new Date().getFullYear();

//       // Ensure only past and current years are included
//       var yearParts = obj.year.split('-');
//       let fromYear = parseInt(yearParts[0]);
//       let toYear = parseInt(yearParts[1]);

//       // Add to pmsYears only if it's not a future year
//       if (toYear <= currentYear) {
//         this.pmsYears.push(obj);
//       }
//     });

//     // Iterate over the years and set the selected year for various fields
//     this.pmsYears?.forEach((ele: any) => {
//       const currentYear = new Date().getFullYear();
//       let yearValue = '';

//       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
//         yearValue = `${currentYear}-${currentYear}`;
//       } else {
//         yearValue = `${currentYear}-${currentYear + 1}`;
//       }

//       if (ele?.year == yearValue) {
//         this.selectedYearForCompetency = ele?.year;
//         var test = ele?.year?.split('-');

//       }
//     });
//     if (this.pmsYears.length > 1) {
//       this.selectedYearForCompetency = this.pmsYears[1].year;
//     } else if (this.pmsYears.length > 0) {
//       this.selectedYearForCompetency = this.pmsYears[0].year;
//     } else {
//       console.warn('pmsYears array is empty');
//       return;
//     }    this.selectedYear = this.selectedYearForCompetency;

//     // Call additional functions if needed
//     if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
//       || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
//       // Add your logic here
//     }
//     var year = this.selectedYearForCompetency?.split('-');
//     if (year?.length != 0) {
//       this.fromYear = year[0];
//       this.toYear = year[1];
//     }

//     this.getMonths(this.fromYear, this.toYear)
//   });
// }

// getpmsyearlist() {
//   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
//     this.pmsYears = [];

//     const currentYear = new Date().getFullYear(); 

//     data?.data?.yearRanges?.forEach((ele: any) => {
//       let test = ele.split('_');
//       let fromYear = parseInt(test[0]);
//       let toYear = parseInt(test[1]);
//       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
//         if (toYear <= currentYear) { 
//           this.pmsYears.push({ year: `${fromYear}-${toYear}` });
//         }
//       } else { 
//         if (toYear <= currentYear + 1) {
//           this.pmsYears.push({ year: `${fromYear}-${toYear}` });
//         }
//       }
//     });

//     this.pmsYears.sort((a: { year: string }, b: { year: string }) => {
//       let [aStart, aEnd] = a.year.split('-').map(Number);
//       let [bStart, bEnd] = b.year.split('-').map(Number);
//       return bEnd - aEnd; 
//     });

//     if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
//       this.selectedYearForCompetency = `${currentYear}-${currentYear}`; 
//     } else {
//       this.selectedYearForCompetency = `${currentYear}-${currentYear + 1}`;
//     }

//     console.log("Selected Fiscal Year:", this.selectedYearForCompetency);

//     console.log("Final Dropdown Options:", this.pmsYears);

//     this.selectedYear = this.selectedYearForCompetency;

//     let year = this.selectedYearForCompetency?.split('-');
//     if (year?.length != 0) {
//       this.fromYear = year[0];
//       this.toYear = year[1];
//     }

//     this.getMonths(this.fromYear, this.toYear);
//   });
// }

getpmsyearlist() {
  this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
    this.pmsYears = formatYearRanges(data?.data?.yearRanges);

    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

    const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
    this.setSelectedYear(yearValue);

    this.getMonths(this.fromYear, this.toYear);
  });
}
setSelectedYear(yearValue: string): void {
  const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
  if (selectedYearObj) {
        this.selectedYearForCompetency = selectedYearObj?.year;
       
        let test = selectedYearObj?.year.split('-');
        this.fromYear = test[0];
        this.toYear = test[1];
  }
}


getYearSetupForReimbursement(year: any) {
  this.selectedYearForCompetency = year;
  console.log(this.selectedYearForCompetency)
  this.getMonths(this.fromYear, this.toYear)

}

fiscalYearMonthsAprilMarch = [
  { key: 4, name: "April" },
  { key: 5, name: "May" },
  { key: 6, name: "June" },
  { key: 7, name: "July" },
  { key: 8, name: "August" },
  { key: 9, name: "September" },
  { key: 10, name: "October" },
  { key: 11, name: "November" },
  { key: 12, name: "December" },
  { key: 1, name: "January" },
  { key: 2, name: "February" },
  { key: 3, name: "March" },
];

fiscalYearMonthsJanDec = [
  { key: 1, name: "January" },
  { key: 2, name: "February" },
  { key: 3, name: "March" },
  { key: 4, name: "April" },
  { key: 5, name: "May" },
  { key: 6, name: "June" },
  { key: 7, name: "July" },
  { key: 8, name: "August" },
  { key: 9, name: "September" },
  { key: 10, name: "October" },
  { key: 11, name: "November" },
  { key: 12, name: "December" },
];




getMonths(fromYear: any, toYear: any) {
  this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec') ? this.fiscalYearMonthsJanDec : this.fiscalYearMonthsAprilMarch;
  this.selectedMonth = new Date().getMonth() + 1;
  console.log(this.selectedMonth);


  const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
    (m: Month) => m.key === this.selectedMonth
  );
  this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


  const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
  this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

  // Find index of selected month for fiscalYearMonthsJanDec
  const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
  this.previousMonthsCountJanDec = this.selectedMonth; // Count from January


  this.fetchSalaryBuckets();
  this.fetchIncrementBuckets();
  this.fetchVPAmountBuckets();
}

onMonthChange(event: any) {
  const selectedMonthKey = event.value;
  this.selectedMonth=selectedMonthKey;
 
  const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
    (m: Month) => m.key === this.selectedMonth
  );
  this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


  const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
  this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

  // Find index of selected month for fiscalYearMonthsJanDec
  const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
  this.previousMonthsCountJanDec = this.selectedMonth; // Count from January


  this.fetchSalaryBuckets();
    // this.fetchIncrementBuckets();
}

  filterFrequencyVariable() {
    switch (this.variableFrequency) {
      case 'Monthly':
        this.filteredFrequenciesVariable = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Quarterly':
        this.filteredFrequenciesVariable = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequenciesVariable = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequenciesVariable = ["Annually"];
        break;
      default:
        this.filteredFrequenciesVariable = this.frequencies;
    }
  }

  filterFrequencies() {
    // Call the get months API from Here and store the result into the setupFrequency
    switch (this.setupFrequency) {
      case 'Monthly':
        this.filteredFrequencies = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Quarterly':
        this.filteredFrequencies = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequencies = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequencies = ["Annually"];
        break;
      default:
        this.filteredFrequencies = this.frequencies;
    }

    this.updatePeriodOptions(this.setupFrequency);
    return of(this.filteredFrequencies);
  }

  updatePeriodOptions(event: any): void {
    let period = this.setupFrequency;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = this.setupFrequency;
    this.httpService.callGetService(
      `${this.config.getVariablePayMonths}/${this.loggedInUserCompanyID}/${period}`
    ).subscribe((response: any) => {
      this.setupMonths = response.data['months'];
      
      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.frequencyName == 'Monthly') {
        this.setupMonths.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
          }
        });
      }

      if (this.frequencyName == 'Quarterly' || this.frequencyName == 'Semi_Annually' || this.frequencyName == 'Semi-Annually'
        || this.frequencyName == 'Annually'
      ) {
        for (let range of this.setupMonths) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
      }
    });

  }
  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }
  clearCutOffDays() {
    this.cutOffDays = null; // Clear the input box
    this.GetOverallIncrementBudgetGridData = [];
    this.fromMonth = null;
    this.cutOffDate = null;
    
  }
  onPeriodChange(event: any) {

    const selectedPeriod = this.frequencyPeriod;
    // Ensure event and value are not undefined

    // Check if selectedPeriod is valid (not undefined or null)
    if (!selectedPeriod) {
      this.selectedMonths = [];
      // this.frequencyPeriod = null;
      this.cutOffDate = null;
      this.cutOffDateForVariablepay = 'Invalid day';
      console.error('Selected period is undefined or null:', selectedPeriod);
      return; // Return an empty observable or handle the error case here
    }

    // If the period is multi-month (e.g., "January-March")
    if (this.frequencyName === 'Quarterly') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);  // Get the months between the period
        if (this.selectedMonths.length > 0) {
          // Calculate the next 3 months after the selected period
          const nextThreeMonths = this.getNextThreeMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set the From and To months to the next three months
          this.fromMonth = nextThreeMonths[0];
          this.toMonth = nextThreeMonths[nextThreeMonths.length - 1];
          this.getMonthsToVariablePay = nextThreeMonths;
        }
      }
    }
    else if (this.frequencyName === 'Monthly') {

      const monthResult = this.getNextMonth(selectedPeriod);
      this.selectedMonth = monthResult.next;  // This will give you the next month
      this.selectedMonths = [selectedPeriod];

      // Get the next 12 months starting from the month after the selected month
      this.getMonthsToVariablePay = [this.selectedMonth];

      this.fromMonth = this.getMonthsToVariablePay[0];
      this.toMonth = this.getMonthsToVariablePay[0];

    }
    else if (this.frequencyName === 'Semi-Annually') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);
        if (this.selectedMonths.length > 0) {
          const nextSixMonths = this.getNextSixMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set From and To months for the next six months
          this.fromMonth = nextSixMonths[0];
          this.toMonth = nextSixMonths[nextSixMonths.length - 1];
          this.getMonthsToVariablePay = nextSixMonths;
        }
      }
    }
    else if (this.frequencyName === 'Annually') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);  // Get the months between the period
        if (this.selectedMonths.length > 0) {
          // Calculate the next 3 months after the selected period
          const nextSixMonths = this.getAnnuallyMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set the From and To months to the next three months
          this.fromMonth = nextSixMonths[0];
          this.toMonth = nextSixMonths[nextSixMonths.length - 1];
          this.getMonthsToVariablePay = nextSixMonths;
        }
      }
    }
    this.onFromMonthChange();
    return of(this.getMonthsToVariablePay);
  }
  getPrevYearSetupVP() {
    const test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.prev_setupsOfVP + this.loggedInUserCompanyID + '/' +
      this.setupFrequency + '/' + test[0] + '/' + test[1] + '/' + this.frequencyPeriod).subscribe((result: any) => {
        
        this.previousOverallVPBudgetGrid = [];
        if (result.data?.length != 0) {
          for (let i = 0; i < result?.data?.length; i++) {
            this.previousOverallVPBudgetGrid.push({
              year: result?.data[i]?.fromYear + '-' + result?.data[i]?.toYear,
              frequencyPeriod: result?.data[i]?.frequency,
              frequencyCycle: result?.data[i]?.frequencyCycle,
              noOfEligibleEmployees: result?.data[i]?.noOfEligibleEmployees ?? 0,
              totalCtcOfEligibleEmployees: result?.data[i]?.totalCtcOfEligibleEmployees ?? 0,
              finalVPPercentage: result?.data[i]?.finalVPPercentage ? result?.data[i]?.finalVPPercentage : null,
              finalVPAmount: result?.data[i]?.finalVPAmount ? result?.data[i]?.finalVPAmount : null,
              isNew: false
            });
          }
        } else {
          this.previousOverallVPBudgetGrid = [];
        }
      });
  }
  
  // Helper function to get the next three months after the last month in the selected period
  getNextThreeMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next three months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 3; i++) {
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);  // Handle wrap-around using modulo
    }

    return nextMonths;
  }

  getNextSixMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next three months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 6; i++) {
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);  // Handle wrap-around using modulo
    }

    return nextMonths;
  }


  getAnnuallyMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next 12 months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 12; i++) {  // Adjusted to get 12 months
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);
    }

    return nextMonths;
  }


  // Function to get the next single month
  getNextMonth(currentMonth: string): { current: string, next: string } {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'
    ];

    const currentIndex = allMonths.indexOf(currentMonth);
    if (currentIndex === -1) return { current: currentMonth, next: currentMonth }; // If invalid month, return it as is

    const nextIndex = (currentIndex + 1) % allMonths.length; // Wrap around to the start if December is selected
    return { current: currentMonth, next: allMonths[nextIndex] };
  }

  getNextTwelveMonths(startIndex: number): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const nextTwelveMonths = [];

    for (let i = 0; i < 12; i++) {
      nextTwelveMonths.push(allMonths[(startIndex + i) % 12]); // Handle wrap-around using modulo
    }

    return nextTwelveMonths;

  }
  
  getMonthsBetween(selectedPeriod: string): string[] {
    const [startMonth, endMonth] = selectedPeriod.split('-');
    const startIndex = this.allMonths.indexOf(startMonth);
    const endIndex = this.allMonths.indexOf(endMonth);

    if (startIndex === -1 || endIndex === -1) {
      console.error('Invalid month range.');
      return [];
    }

    // Check if the range wraps around the year (e.g., October-March)
    if (startIndex <= endIndex) {
      // No wrap-around, return months within the same year
      return this.allMonths.slice(startIndex, endIndex + 1);
    } else {
      // Wrap-around case, combine months from the end of the year and the start of the year
      return [...this.allMonths.slice(startIndex), ...this.allMonths.slice(0, endIndex + 1)];
    }
  }
  onFromMonthChange() {
    const startIndex = this.getMonthsToVariablePay.indexOf(this.fromMonth);

    if (startIndex !== -1) {
      // Include the "From Month" in the available "To Month" options
      this.toMonthsVariablePay = this.getMonthsToVariablePay.slice(startIndex);
    } else {
      this.toMonthsVariablePay = [];
    }
  }
  processCutoffDateInput(day: string): void {
    const parsedDay = parseInt(day, 10);
    if (parsedDay && parsedDay > 0) {
      this.cutOffDays = parsedDay; // Update cutOffDays

      // Convert parsedDay back to a string for calculateCutoffDate
      this.calculateCutoffDate(parsedDay.toString());
      // Trigger the API call
      // this.getCutOffDataForApi();
    } else {
      console.warn('Invalid cutoff day input. API call not triggered.');
    }
  }

  calculateCutoffDate(day: string): void {
    const dayNumber = parseInt(day, 10);
    if (this.frequencyName === 'Monthly') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 30) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Quarterly') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 90) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Semi-Annually') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 180) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Annually') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 365) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }

    if (this.selectedMonths.length > 0) {
      const monthDays: { [key: string]: number } = {
        'January': 31,
        'February': this.isLeapYear(new Date().getFullYear()) ? 29 : 28,
        'March': 31,
        'April': 30,
        'May': 31,
        'June': 30,
        'July': 31,
        'August': 31,
        'September': 30,
        'October': 31,
        'November': 30,
        'December': 31
      };

      const firstMonth = this.selectedMonths[0];
      let currentYear = new Date().getFullYear(); // Use the current year
      let currentMonth = firstMonth;
      let remainingDays = dayNumber;
      let calculatedDay = 0;

      // Helper to get the next month
      const getNextMonth = (current: string): string => {
        const months = Object.keys(monthDays);
        const currentIndex = months.indexOf(current);
        return months[(currentIndex + 1) % 12]; // Cycle through months
      };

      // Loop through the months and subtract the days
      while (remainingDays > 0) {
        const daysInCurrentMonth = monthDays[currentMonth];
        if (remainingDays <= daysInCurrentMonth) {
          calculatedDay = remainingDays; // Final cutoff day within the current month
          break;
        } else {
          remainingDays -= daysInCurrentMonth; // Move to next month
          currentMonth = getNextMonth(currentMonth); // Get next month

          // Check if we need to increment the year
          if (currentMonth === 'January') {
            currentYear++; // Increment the year when we reach January
          }
        }
      }

      // Format the month number and the date
      const formattedMonth = this.formatMonthToNumber(currentMonth as 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December');
      this.cutOffDateForVariablepay = `${calculatedDay.toString().padStart(2, '0')}/${formattedMonth}/${currentYear}`;
    }
    this.employeeCountOnDateChange();
  }
  employeeCountOnDateChange() {
    const cutOffDate = this.datePipe.transform(this.cutOffDateForVariablepay, "yyyy-MM-dd");
    this.httpService.callGetService(this.config.empcount_ctc + this.loggedInUserCompanyID + '/' + cutOffDate+'/'+this.setupFrequency).subscribe((result: any) => {

    });
  }
  // Helper function to check for leap year
  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  // Helper function to format month names into numbers
  formatMonthToNumber(month: 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December'): string {
    const months = {
      'January': '01', 'February': '02', 'March': '03', 'April': '04',
      'May': '05', 'June': '06', 'July': '07', 'August': '08',
      'September': '09', 'October': '10', 'November': '11', 'December': '12'
    };
    return months[month]; // TypeScript now knows that 'month' will be a valid key
  }

  selectGraphType: any = 'bar';
  selectedFromDated: any;
  selectedtoDated: any;
  taskFromDate: any;
  taskToDate: any;

  formatDateToISO(date: Date): string {
    const pad = (num: number): string => String(num).padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
  }
  processFirstGraphDateRange(): void {
    if (this.taskFromDate && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = new Date(this.taskToDate);

      fromDate.setHours(0, 0, 0, 0);  // Start of the day
      toDate.setHours(23, 59, 59, 999); // End of the day

      const formattedFromDate = this.formatDateToISO(fromDate) + "T00:00:00";
      const formattedToDate = this.formatDateToISO(toDate) + "T23:59:59";

      this.selectedFromDated = formattedFromDate;
      this.selectedtoDated = formattedToDate;



    } else {
      console.log('No filtering applied for Graph 1, returning all data');
    }
  }

  downloadChartAsPDF(type: string): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

    const formattedFromDate = this.selectedMonthName;
    console.log("formattedFromDate",formattedFromDate);
    
    // const formattedToDate = this.selectedtoDated ? formatDate(this.selectedtoDated) : '';

    const idMapping: { [key: string]: string } = {
      'Salary Range Attrition':this.isSalaryRangeTable ? 'table-Salary-Range-data' : 'salary-range-chart',
      'Increment Attrition':this.isIncrementRateTable ? 'table-Increment-Attrition-data' : 'increment-chart',
     
    };


    const idSelector = idMapping[type] || 'default-chart-id';

    const selectedYearForReimbursement = this.loggedInCompanyFiscalyear === "Jan_Dec"
      ? this.selectedYearForCompetency.split("-")[0]
      : this.selectedYearForCompetency;

    // Call the common function from the service
    this.PdfDownload.downloadPDFMonthwise(
      idSelector, // Chart ID
      type, // Title
      selectedYearForReimbursement, // Year
      formattedFromDate, // From Date
    );
  }
// --------------------------Salary Range-----------------------------
public isSalaryRangeChartIcon: string = 'bar';
public isSalaryRangeTable: boolean = false;
public isSalaryRangeTableGraph: any[] = [];
public selectGraphSalaryRangeType: any = 'bar';
public salaryRangeData: any;
public salaryBuckets:any;
fetchSalaryBuckets(): void {
  this.httpService.callGetService(`${this.config.salaryBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
    .subscribe({
      next: (data: any) => {
        this.salaryBuckets = data.data;
        console.log('salaryBuckets', this.salaryBuckets);
        this.fetchSalaryRange();

      },
      error: (err) => {
        console.error('Error fetching salary buckets:', err);
      }
    });
}
fetchSalaryRange(): void {
  this.httpService.callGetService(`${this.config.salaryRangeDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}&month=${this.selectedMonth}`)
    .subscribe({
      next: (data: any) => {
        this.salaryRangeData = data;
        console.log('Salary Range Data:', this.salaryRangeData);
        this.salaryRangeGraph('bar');
      },
      error: (err) => {
        console.error('Error fetching salary range data:', err);
      }
    });
}

salaryRangeChart(graphType: any) {
  this.selectGraphSalaryRangeType = graphType;
  this.isSalaryRangeChartIcon = graphType;
  this.isSalaryRangeTable = false;
  this.salaryRangeGraph(this.selectGraphSalaryRangeType);
}

salaryRangeChartTable() {
  this.selectGraphSalaryRangeType = 'table';
  this.isSalaryRangeChartIcon = '';
  this.isSalaryRangeTable = true;
}

salaryRangeLineGraph(data: any, idSelector: any, graphType: any): void {
  createChartSingle(idSelector, 'line', graphType, data, {
    xAxisName: data.xAxisName,
    yAxisName: data.yAxisName,
  });
}

salaryRangeBarGraph(data: any, idSelector: any, graphType: any): void {
  createChartSingle(idSelector, 'bar', graphType, data, {
    xAxisName: data.xAxisName,
    yAxisName: data.yAxisName,
  });
}

salaryRangeGraph(graphType: string) {
  console.log("Salary Range Data:", this.salaryRangeData);

  if (!this.salaryRangeData?.data?.length || !this.salaryBuckets?.length) {
    console.warn("Data Not Found: Salary Range data or Salary Range Buckets are missing");
    this.isSalaryRangeTableGraph = [];
    const chartElement = document.getElementById('salary-range-chart') as HTMLDivElement;
    if (chartElement) {
      echarts.init(chartElement).clear();
    }
    return;
  }

  const salaryRangeBucketData = this.salaryBuckets.map((bucket: any) => ({
    range: `${bucket.lowerEnd}-${bucket.upperEnd}`,
    count: 0
  }));

  this.salaryRangeData.data.forEach((salary: any) => {
    const salaryAmount = parseFloat(salary.SalaryRange); // Ensure numeric value

    const bucket = salaryRangeBucketData.find((b: any) =>
      salaryAmount >= +b.range.split('-')[0] && salaryAmount < +b.range.split('-')[1]
    );
    if (bucket) {
      bucket.count += salary.count;
    }
  });

  const previousMonthsCount =
  this.loggedInCompanyFiscalyear === "Jan_Dec"
    ? this.previousMonthsCountJanDec
    : this.previousMonthsCountAprilMarch;

  let transformedData: any[] = [];
  if (graphType === 'pie') {
    transformedData = salaryRangeBucketData.map((bucket: any) => ({
      name: bucket.range,
      value: bucket.count,
      percentage: ((bucket.count / this.salaryRangeData.data.length) * 100).toFixed(2),
      annualizedAttrition: ((+bucket.count * 12) / previousMonthsCount).toFixed(2)
    }));
  } else {
    transformedData = salaryRangeBucketData.map((bucket: any) => ({
      xAxisValueData: bucket.range,
      seriesValueOneData: bucket.count,
      seriesValueTwoData: +((bucket.count / this.salaryRangeData.data.length) * 100).toFixed(2),
      seriesValueThreeData: +((bucket.count * 12) / previousMonthsCount).toFixed(2),
      xAxisName: 'Salary Range',
      yAxisName: 'Employee Count',
      seriesLabelOne: 'Employee Count',
      seriesLabelTwo: 'Attrition %',
      seriesLabelThree: 'Annualized Attrition %'

    }));
  }

  console.log("Transformed Salary Range Data:", transformedData);
  this.isSalaryRangeTableGraph = transformedData;

  if (graphType === 'pie') {
    const pieChartOptions = this.attritionPieChartOptions(transformedData);
    echarts.init(document.getElementById('salary-range-chart') as HTMLDivElement).setOption(pieChartOptions);
  } else {
    const seriesLabels = {
      xAxisName: 'Salary Ranges',
      yAxisName: 'Count'
    };

    const graphFunctions: Record<string, Function> = {
      bar: this.salaryRangeBarGraph,
      line: this.salaryRangeLineGraph
    };

    const renderGraph = graphFunctions[graphType];
    if (renderGraph) {
      renderGraph.call(this, transformedData, 'salary-range-chart', 'single', seriesLabels);
    }
  }
}
//-----------------Increment----------------------
public isIncrementRateTable: boolean = false;
public isIncrementTableGraph: any[] = [];
public selectGraphIncrementType: any = 'bar';
public incrementData: any;
public incrementBuckets: any;
public isIncrementRateIcon: string = 'bar';

incrementRate(graphType: any) {
  this.selectGraphIncrementType = graphType;
  this.isIncrementRateIcon = graphType;
  this.isIncrementRateTable = false;
  this.incrementGraph(this.selectGraphIncrementType);
}

incrementRateTable() {
  this.selectGraphIncrementType = 'table';
  this.isIncrementRateIcon = '';
  this.isIncrementRateTable = true;
}

incrementBarGraph(data: any, idSelector: any, graphType: any): void {
  createChartSingle(idSelector, 'bar', graphType, data, {
    xAxisName: data.xAxisName,
    yAxisName: data.yAxisName,
  });
}

incrementLineGraph(data: any, idSelector: any, graphType: any): void {
  createChartSingle(idSelector, 'line', graphType, data, {
    xAxisName: data.xAxisName,
    yAxisName: data.yAxisName,
  });
}

fetchIncrementBuckets(): void {
  this.httpService.callGetService(`${this.config.incrementBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
    .subscribe({
      next: (data: any) => {
        this.incrementBuckets = data.data;
        console.log('incrementBuckets', this.incrementBuckets);
        this.fetchIncrementData();
      },
      error: (err) => {
        console.error('Error fetching increment buckets:', err);
      }
    });
}

fetchIncrementData(): void {
  this.httpService.callGetService(`${this.config.incrementDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
  // this.httpService.callGetService(`${this.config.incrementDataUrl}?companyId=310&year=2024-2025`)
  .subscribe({
      next: (data: any) => {
        this.incrementData = data;
        console.log('Increment Data:', this.incrementData);
        this.incrementGraph('bar');
      },
      error: (err) => {
        console.error('Error fetching increment data:', err);
      }
    });
}

incrementGraph(graphType: string) {
  console.log("Increment Data:++++++++++++", this.incrementData);

  if (!this.incrementData?.data?.length|| !this.incrementBuckets?.length) {
    console.warn("Data Not Found: Increment data  or Increment Buckets are missing");
    this.isIncrementTableGraph = [];
    const chartElement = document.getElementById('increment-chart') as HTMLDivElement;
    if (chartElement) {
      echarts.init(chartElement).clear();
    }
    return;
  }
  const previousMonthsCount =
  this.loggedInCompanyFiscalyear === "Jan_Dec"
    ? this.previousMonthsCountJanDec
    : this.previousMonthsCountAprilMarch;
    // Map PMS Score Data to Performance Buckets
    const incrementBucketRange = this.incrementBuckets.map((bucket: any) => ({
      range: `${bucket.lowerEnd}-${bucket.upperEnd}`,
      count: 0
    }));

    // Categorize PMS Score Data
    this.incrementData.data.forEach((score: any) => {
      const Increment = score.Increment;
      const bucket = incrementBucketRange.find((b: any) =>
        Increment >= +b.range.split('-')[0] && Increment < +b.range.split('-')[1]
      );
      if (bucket) {
        bucket.count += 1; // Count users in each bucket
      }
    });

    let transformedData: any[] = [];
    if (graphType === 'pie') {
      transformedData = incrementBucketRange.map((bucket: any) => ({
        name: bucket.range,
        value: bucket.count,
        attritionPercentage: ((bucket.count / this.incrementData.data.length) * 100).toFixed(2),
        annualizedAttrition: ((+bucket.count * 12) / previousMonthsCount).toFixed(2)
      }));
    } else {
      transformedData = incrementBucketRange.map((bucket: any) => ({
        xAxisValueData: bucket.range,
        seriesValueOneData: bucket.count,
        seriesValueTwoData: +((bucket.count / this.incrementData.data.length) * 100).toFixed(2),
        seriesValueThreeData: +((bucket.count * 12) / previousMonthsCount).toFixed(2),
        xAxisName: 'Increment %',
        yAxisName: 'Attrition Count',
        seriesLabelOne: 'Attrition Count',
        seriesLabelTwo: 'Attrition %',
        seriesLabelThree: 'Annualized Attrition %'
      }));
    }

    console.log("Transformed PMS Score Data:", transformedData);
    this.isIncrementTableGraph = transformedData;

  if (graphType === 'pie') {
    const pieChartOptions = this.attritionPieChartOptions(transformedData);
    echarts.init(document.getElementById('increment-chart') as HTMLDivElement).setOption(pieChartOptions);
  } else {
    const seriesLabels = {
      xAxisName: 'Increment Buckets',
      yAxisName: 'Count'
    };

    const graphFunctions: Record<string, Function> = {
      bar: this.incrementBarGraph,
      line: this.incrementLineGraph
    };

    const renderGraph = graphFunctions[graphType];
    if (renderGraph) {
      renderGraph.call(this, transformedData, 'increment-chart', 'single', seriesLabels);
    }
  }
}

//-----------------VP Amount----------------------
public isVPAmountTable: boolean = false;
public isVPAmountTableGraph: any[] = [];
public selectGraphVPAmountType: any = 'bar';
public vpAmountData: any;
public vpAmountBuckets: any;
public isVPAmountIcon: string = 'bar';

vpAmountRate(graphType: any) {
  this.selectGraphVPAmountType = graphType;
  this.isVPAmountIcon = graphType;
  this.isVPAmountTable = false;
  this.vpAmountGraph(this.selectGraphVPAmountType);
}

vpAmountRateTable() {
  this.selectGraphVPAmountType = 'table';
  this.isVPAmountIcon = '';
  this.isVPAmountTable = true;
}

fetchVPAmountBuckets(): void {
  this.httpService.callGetService(`${this.config.vpAmountBucketUrl}?companyId=${this.loggedInUserCompanyID}&fiscalYear=${this.selectedYearForCompetency}`)
    .subscribe({
      next: (data: any) => {
        this.vpAmountBuckets = data.data;
        console.log('VP Amount Buckets:', this.vpAmountBuckets);
        this.fetchVPAmountData();
      },
      error: (err) => {
        console.error('Error fetching VP Amount buckets:', err);
      }
    });
}

fetchVPAmountData(): void {
  this.httpService.callGetService(`${this.config.vpAmountDataUrl}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}&frequencyCycle=january-march`)
    .subscribe({
      next: (data: any) => {
        this.vpAmountData = data;
        console.log('VP Amount Data:', this.vpAmountData);
        this.vpAmountGraph('bar');
      },
      error: (err) => {
        console.error('Error fetching VP Amount data:', err);
      }
    });
}

vpAmountGraph(graphType: string) {
  console.log('VP Amount Data:', this.vpAmountData);

  if (!this.vpAmountData?.data?.length || !this.vpAmountBuckets?.length) {
    console.warn('Data Not Found: VP Amount data or VP Amount Buckets are missing');
    this.isVPAmountTableGraph = [];
    const chartElement = document.getElementById('vpamount-chart') as HTMLDivElement;
    if (chartElement) {
      echarts.init(chartElement).clear();
    }
    return;
  }

  const vpAmountBucketRange = this.vpAmountBuckets.map((bucket: any) => ({
    range: `${bucket.lowerEnd}-${bucket.upperEnd}`,
    count: 0
  }));

  this.vpAmountData.data.forEach((amount: any) => {
    const vpAmount = amount.VPAmount;
    const bucket = vpAmountBucketRange.find((b: any) =>
      vpAmount >= +b.range.split('-')[0] && vpAmount < +b.range.split('-')[1]
    );
    if (bucket) {
      bucket.count += 1;
    }
  });

  const transformedData = vpAmountBucketRange.map((bucket: any) => ({
    xAxisValueData: bucket.range,
    seriesValueOneData: bucket.count,
    seriesValueTwoData: +((bucket.count / this.vpAmountData.data.length) * 100).toFixed(2),
    xAxisName: 'VP Amount Buckets',
    yAxisName: 'User Count',
    seriesLabelOne: 'VP Count',
    seriesLabelTwo: 'VP %',
    seriesLabelThree: 'Annualized Attrition %'
  }));

  console.log('Transformed VP Amount Data:', transformedData);
  this.isVPAmountTableGraph = transformedData;
 if (graphType === 'pie') {
        const pieChartOptions = this.attritionPieChartOptions(transformedData);
        echarts.init(document.getElementById('vpamount-chart') as HTMLDivElement).setOption(pieChartOptions);
      } else {
        const seriesLabels = {
          xAxisName: 'VP Amount Buckets',
          yAxisName: 'Attrition Count'
        };
      
  // const seriesLabels = { xAxisName: 'VP Amount Buckets', yAxisName: 'Count' };
  const graphFunctions: Record<string, Function> = {
    bar: this.incrementBarGraph,
    line: this.incrementLineGraph
  };

  const renderGraph = graphFunctions[graphType];
  if (renderGraph) {
    renderGraph.call(this, transformedData, 'vpamount-chart', 'single', seriesLabels);
  }
}}

attritionPieChartOptions(data: any): echarts.EChartsOption {
  return {
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        // console.log(params);

        // Extract all available data dynamically
        let tooltipContent = `<strong>${params.name}</strong><br/>`;
        Object.keys(params.data).forEach((key) => {
          if (key !== 'name' && key !== 'value') {
            const formattedKey = key.replace(/([A-Z])/g, ' $1').trim(); // Convert camelCase to spaced words
            tooltipContent += `${formattedKey}: <strong>${params.data[key]}</strong><br/>`;
          }
        });

        return tooltipContent;
      }
    },
    legend: {
      bottom: 0
    },
    color: [
      '#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#FAC858', 
      '#9A60B4', '#EA7CCC', '#3BA${this.loggedInUserCompanyID}', '#FC8452', '#B4A7D6'
    ], 
    series: [
      {
        name: 'Department',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          formatter: (params: any) => {
            return `${params.name}: ${params.value}`; // Dynamic label with department & count
          }
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: true
        },
        data: data
      }
    ],
    xAxis: { show: false },  // Hide xAxis for pie chart
    yAxis: { show: false }
  };
}



}
